import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Container } from 'rsuite';
import { changeSideMenu } from '../../../../../actions/actionsMenu';
import { LoadingSpinerArea } from '../../../../../components';
import { mapMonitoramentoDetalheToFormInitialValues, useCriarMonitoramentoForm } from '../hooks/useCriarMonitoramentoForm';
import { MonitoramentoDetalheDTO } from '../types';
import {
  CompartilhamentoForm,
  DetalhamentoMonitoramentoForm,
  FormFooter,
  MonitoringTypeForm,
  NomeMonitoramentoForm,
  PreferencesForm,
  RegraNotificacaoForm,
  VoltarLink,
} from '../Components';
import styles from './CriarMonitoramento.module.scss';

type CriarMonitoramentoLocationState = {
  duplicateFrom?: MonitoramentoDetalheDTO;
};

export const CriarMonitoramento = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams<{ id?: string }>();
  const location = useLocation<CriarMonitoramentoLocationState | undefined>();
  const duplicateFrom = location.state?.duplicateFrom;

  const {
    isEditMode,
    nomeMonitoramento,
    setNomeMonitoramento,
    monitoringType,
    setMonitoringType,
    detalhamento,
    setDetalhamento,
    regraNotificacao,
    setRegraNotificacao,
    priceType,
    setPriceType,
    physicalChannel,
    setPhysicalChannel,
    digitalChannel,
    setDigitalChannel,
    compartilhadoCom,
    setCompartilhadoCom,
    isSubmitting,
    isLoadingDetalhe,
    handleSubmit,
  } = useCriarMonitoramentoForm({ id, initialValues: duplicateFrom ? mapMonitoramentoDetalheToFormInitialValues(duplicateFrom) : undefined });

  useEffect(() => {
    dispatch(changeSideMenu('4'));
  }, [dispatch]);

  const handleCancel = () => {
    history.push('/isa/central-de-monitoramento');
  };

  const handleSubmitAndNavigate = async () => {
    const detalhe = await handleSubmit();
    if (detalhe) {
      history.push('/isa/central-de-monitoramento');
    }
  };

  return (
    <Container className={`main-container ${styles.container}`}>
      <LoadingSpinerArea area="central-de-monitoramento" size="md" style={{ position: 'absolute' }} />
      <VoltarLink />
      <NomeMonitoramentoForm value={nomeMonitoramento} onChange={setNomeMonitoramento} />
      <MonitoringTypeForm value={monitoringType} onChange={setMonitoringType} />
      <DetalhamentoMonitoramentoForm monitoringType={monitoringType} value={detalhamento} onChange={setDetalhamento} />
      <RegraNotificacaoForm value={regraNotificacao} onChange={setRegraNotificacao} />
      <PreferencesForm
        priceType={priceType}
        onChangePriceType={setPriceType}
        physicalChannel={physicalChannel}
        onChangePhysicalChannel={setPhysicalChannel}
        digitalChannel={digitalChannel}
        onChangeDigitalChannel={setDigitalChannel}
      />
      <CompartilhamentoForm value={compartilhadoCom} onChange={setCompartilhadoCom} />
      <FormFooter
        onCancel={handleCancel}
        onSubmit={handleSubmitAndNavigate}
        isSubmitting={isSubmitting || isLoadingDetalhe}
        submitLabel={isEditMode ? 'SALVAR ALTERAÇÕES' : undefined}
      />
    </Container>
  );
};
